import { render } from "./TopWellnessCandidates.vue?vue&type=template&id=531e07ba&scoped=true"
import script from "./TopWellnessCandidates.vue?vue&type=script&lang=js"
export * from "./TopWellnessCandidates.vue?vue&type=script&lang=js"

import "./TopWellnessCandidates.vue?vue&type=style&index=0&id=531e07ba&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531e07ba"]])

export default __exports__